module.exports = __webpack_public_path__ + "img/app_code.483c31b.png";